import $ from '../core/Dom';
import Viewport from '../core/Viewport';
import Dispatch from '../core/Dispatch';
import scrollLock from 'scroll-lock';
import * as eventKeys from '../lib/events';


export default (el, props) => {
    const COLOR_PEACH = '#F68F69';
    const COLOR_WHITE = '#FFF';
        
    const $el = $(el);
    const $scrollWrapper = $el.find('[data-menu-scroll-wrapper]');
    const $body = $('body');
    const $menuContent = $el.find('[data-menu-content]');
    
    let isOpen = false;

    const resetMenu = () => {
        $el.css({ display: 'none', height: '100vh' });
        $menuContent.css({ opacity: 0 });

        const scrollWrapper = $scrollWrapper.get(0);
        // Hotfix to prevent an exception in older Safari versions when doing `scrollLock.enablePageScroll()` _before_ first doing `scrollLock.disablePageScroll`
        if (!scrollWrapper.dataset.scrollLockScrollable) {
            scrollWrapper.dataset.scrollLockScrollable = '';
        }
        scrollLock.enablePageScroll($scrollWrapper.get(0));
    };
    
    const openMenu = () => {
        Dispatch.emit(eventKeys.LOCK_MENU_BAR);
        scrollLock.disablePageScroll($scrollWrapper.get(0));
        
        $el.css({ display: 'block', opacity: 0, backgroundColor: COLOR_PEACH });
        TweenLite.to($el.nodes, 0.3, { opacity: 1, ease: Linear.easeNone });
        TweenLite.to($menuContent.nodes, 0.6, { delay: 0.5, opacity: 1, ease: Linear.easeNone });
        
        $body.addClass('-menu-open');
        isOpen = true;
    };
    
    const closeMenu = () => {
        Dispatch.emit(eventKeys.UNLOCK_MENU_BAR);
        
        TweenLite.to($menuContent.nodes, 0.2, { opacity: 0, ease: Linear.easeNone });
        TweenLite.to($el.nodes, 0.4, { delay: 0.3, opacity: 0, ease: Linear.easeNone, onComplete: () => {
            resetMenu();
        } });
        
        $body.removeClass('-menu-open');
        isOpen = false;
    };
    
    const onMenuToggle = () => {
        if (isOpen) {
            Dispatch.emit(eventKeys.MENU_CLOSE);
        } else {
            Dispatch.emit(eventKeys.MENU_OPEN);
        }
    };
    
    const onMenuOpen = () => {
        if (!isOpen) {
            openMenu();
        }
    };
    
    const onMenuClose = () => {
        if (isOpen) {
            closeMenu();
        }
    };
    
    const onResize = e => {
        e.preventDefault();
    };
    
    const onBreakpoint = e => {
        e.preventDefault();
    };
    
    const onKeyup = e => {
        const key = e.keyCode || e.which;
        if (key === 27) {
            Dispatch.emit(eventKeys.MENU_CLOSE);
        }
    };

    const onInfoPanelVisible = () => {
        if (!isOpen) {
            return;
        }
        Dispatch.emit(eventKeys.MENU_CLOSE);
    };
    
    const init = () => {
        $el.addClass('js-header-enabled');
        resetMenu();
        document.addEventListener('keyup', onKeyup);
        
        Dispatch.on(eventKeys.MENU_TOGGLE, onMenuToggle);
        Dispatch.on(eventKeys.MENU_OPEN, onMenuOpen);
        Dispatch.on(eventKeys.MENU_CLOSE, onMenuClose);

        Dispatch.on(eventKeys.INFORMATION_PANEL_VISIBLE, onInfoPanelVisible, true);
        
        Viewport.on('breakpoint', onBreakpoint);
        Viewport.on('resize', onResize);
    };

    const destroy = () => {
        document.removeEventListener('keyup', onKeyup);

        Dispatch.off(eventKeys.MENU_TOGGLE, onMenuToggle);
        Dispatch.off(eventKeys.MENU_OPEN, onMenuOpen);
        Dispatch.off(eventKeys.MENU_CLOSE, onMenuClose);

        Dispatch.off(eventKeys.INFORMATION_PANEL_VISIBLE, onInfoPanelVisible);
        
        Viewport.off('breakpoint', onBreakpoint);
        Viewport.off('resize', onResize);
    };

    return {
        init,
        destroy
    };
};
